$(document).ready(function() {
    var main_product = $('.main-product').attr('data-pro-handle');
    $('.radio-bundle__item').each(function(){
      var pro_handle = $(this).find('.radio-bundle__item-box').attr('data-pro-handle');
      if(main_product == pro_handle ){
        $('.radio-bundle__item-box[data-pro-handle=' + pro_handle + ']').parents('.radio-bundle__item').addClass('active');
        var secondActive = $('.radio-bundle__item-box[data-pro-handle=' + pro_handle + ']').parents('.radio-bundle__item.active').eq(1);
        if (secondActive.length > 0) {
        secondActive.hide();
        }
      }
    });


    var addToCartButton = $('.add-btn1');
    var stickyButton = $('.sticky-button');
    var defaultPosition = 1300 // Replace with the actual default position
    var isVisible = false;
    $(window).on('scroll', function() {
      var scrollTop = $(this).scrollTop();
      // Show/hide the sticky button based on scroll position
      if (scrollTop > defaultPosition && !isVisible) {
        stickyButton.css('bottom', '25px'); // Show the sticky button
        isVisible = true;
      } else if (scrollTop <= defaultPosition && isVisible) {
        stickyButton.css('bottom', '-60px'); // Hide the sticky button
        isVisible = false;
      }
    });

    function updateBundleProgressBar(bundleTotal) {
      const maxThreshold = Number($('.progress-bundle-wrapper__heading-left').attr('data-free-shipping')) / 100;
      const progressBar = $('.progress-bundle__bar-inner');
  
      let percentage = (bundleTotal / maxThreshold) * 100;
      percentage = Math.min(percentage, 100);
  
      $('.progress-bundle__bar-inner').css('width', `${percentage}%`);
    }

    function checkTotal() {
      let total = 0; // Initialize a global variable to store the total price
      let subscribeTotal = 0;
      let qtyTotal = 0;
      let freeShippingThreshold = Number($('.progress-bundle-wrapper__heading-left').attr('data-free-shipping'));

      let cartTotal = 0;
      fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => { 
        cartTotal = data.total_price;

        $('.bundle-new-flavors__quantity').each(function() {
          let currentQty = parseFloat($(this).find('input').val()); // Get the quantity as a float
          let currentPrice = parseFloat($(this).find('input').attr('data-item-price')); // Get the price as a float
          let currentSubscribePrice = parseFloat($(this).find('input').attr('data-item-subscription-price'));
          
          if (!isNaN(currentQty) && !isNaN(currentPrice)) { // Ensure both are numbers
              let totalPrice = currentQty * currentPrice; // Calculate the total price for this item
              total += totalPrice; // Add the totalPrice to the global total
          }
  
          if (!isNaN(currentQty) && !isNaN(currentSubscribePrice)) {
            let totalSubPrice = currentQty * currentSubscribePrice;
            subscribeTotal += totalSubPrice;
          }
  
          if (!isNaN(currentQty)) {
            qtyTotal += currentQty;
          }
      });
  
      if (qtyTotal == 0) {
        $(`.frequency-bundle .frequency-bundle__work-desc .label-bag span`).text('X');
      } else {
        $(`.frequency-bundle .frequency-bundle__work-desc .label-bag span`).text(qtyTotal);
      }
  
      let properMoney = total / 100;
      let remainPrice = freeShippingThreshold - cartTotal - total;
      let remainPriceInMoney = Shopify.formatMoney(remainPrice);
  
      let totalOneTimePrice = Shopify.formatMoney(total);
      
      let originalOnetimePrice = $('.bundle-new-flavors__list input[name="flavor-radio"]:checked').attr('data-product-onetime-price');
  
      if (total == 0) {
        $('.frequency-bundle__one-time-heading .onetime_price').text(originalOnetimePrice);
        $(`.frequency-bundle .frequency-bundle__work-desc-price p.bundle_price s`).text(originalOnetimePrice);
      } else {
        $('.frequency-bundle__one-time-heading .onetime_price').text(totalOneTimePrice);
        $(`.frequency-bundle .frequency-bundle__work-desc-price p.bundle_price s`).text(totalOneTimePrice);
      }
  
      let originalSubsPrice = $('.bundle-new-flavors__list input[name="flavor-radio"]:checked').attr('data-product-sub-price');
  
      let multiplySubsPrice = subscribeTotal * 100;
      let properSubsMoneyPrice = Shopify.formatMoney(multiplySubsPrice);
      if (total == 0) {
        $('.frequency-bundle__work-desc-price .bundle_price strong').text(originalSubsPrice);
      } else {
        $('.frequency-bundle__work-desc-price .bundle_price strong').text(properSubsMoneyPrice);
      }
  
      //console.log('remainPrice onetime', remainPrice)
      if (remainPrice <= 0) {
        $('.progress-bundle-wrapper__heading .progress-bundle-wrapper__heading-left').html("Congrats! you've unlocked free shipping.");
        $('.progress-bundle-wrapper__heading-mob .progress-bundle-wrapper__heading-left').html("Congrats! you've unlocked free shipping.");
  
        $('.frequency-bundle__deliver .progress-bundle-wrapper__heading-right').addClass('hide-msg');
        $('.progress-bundle-wrapper__heading-mob .progress-bundle-wrapper__heading-right').addClass('hide-msg');
      } else {
        //$('.progress-bundle-wrapper__heading .progress-bundle-wrapper__heading-left span').text(remainPriceInMoney);
        $('.progress-bundle-wrapper__heading .progress-bundle-wrapper__heading-left').html(`You're <span>${remainPriceInMoney}</span> away from Free Shipping.`);
        $('.progress-bundle-wrapper__heading-mob .progress-bundle-wrapper__heading-left').html(`You're <span>${remainPriceInMoney}</span> away from Free Shipping.`);
        
        $('.frequency-bundle__deliver .progress-bundle-wrapper__heading-right').addClass('hide-msg');
        $('.progress-bundle-wrapper__heading-mob .progress-bundle-wrapper__heading-right').addClass('hide-msg');
      }
  
      if (total <= 0) {            
        $('.product-count button.add-btn1').attr('disabled', 'disabled');
        $('.product-count .sticky-button').attr('disabled', 'disabled');
      } else {
        $('.product-count button.add-btn1').removeAttr('disabled');
        $('.product-count .sticky-button').removeAttr('disabled');
      }
  
      let allTotal = (cartTotal + total) / 100;
      updateBundleProgressBar(allTotal);

      let onetimeTotal = Shopify.formatMoney(total);
      $('p[title="order-total"] span').text(onetimeTotal);

      });

      
    }


    function subscriptionTotalCheck() {
      let total = 0; // Initialize a global variable to store the total price
      let oneTimeTotal = 0;
      let qtyTotal = 0;
      let freeShippingThreshold = Number($('.progress-bundle-wrapper__heading-left').attr('data-free-shipping'));


      let cartTotal = 0;
      fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {
        cartTotal = data.total_price;

        $('.bundle-new-flavors__quantity').each(function() {
          let currentQty = parseFloat($(this).find('input').val()); // Get the quantity as a float
          let currentPrice = parseFloat($(this).find('input').attr('data-item-subscription-price')); // Get the price as a float

          // one time price calculation for check saving
          let currentOneTimePrice = parseFloat($(this).find('input').attr('data-item-price'));
          if (!isNaN(currentQty) && !isNaN(currentOneTimePrice)) {
            let totalOneTimePrice = currentQty * currentOneTimePrice;
            oneTimeTotal += totalOneTimePrice;
          }

          if (!isNaN(currentQty) && !isNaN(currentPrice)) { // Ensure both are numbers
              let totalPrice = currentQty * currentPrice; // Calculate the total price for this item
              total += totalPrice; // Add the totalPrice to the global total
          }

          if (!isNaN(currentQty)) {
            qtyTotal += currentQty;
          }
      });

      if (qtyTotal == 0) {
        $(`.frequency-bundle .frequency-bundle__work-desc .label-bag span`).text('X');
      } else {
        $(`.frequency-bundle .frequency-bundle__work-desc .label-bag span`).text(qtyTotal);
      }

      let multiplyPrice = total * 100;
      let remainPrice = freeShippingThreshold - cartTotal - multiplyPrice;
      let remainPriceInMoney = Shopify.formatMoney(remainPrice);

      // onetime
      let totalSaving = oneTimeTotal - multiplyPrice; // one time - subscription
      let savingInMoney = Shopify.formatMoney(totalSaving);

      let totalSubsciptionPrice = Shopify.formatMoney(multiplyPrice);
      let totalOneTimePrice = Shopify.formatMoney(oneTimeTotal);

      let originalOnetimePrice = $('.bundle-new-flavors__list input[name="flavor-radio"]:checked').attr('data-product-onetime-price');
      let originalSubsPrice = $('.bundle-new-flavors__list input[name="flavor-radio"]:checked').attr('data-product-sub-price');

      if (total == 0) {
        $('.frequency-bundle__one-time-heading .onetime_price').text(originalOnetimePrice);
        $(`.frequency-bundle .frequency-bundle__work-desc-price p.bundle_price s`).text(originalOnetimePrice);
        $('.frequency-bundle__work-desc-price .bundle_price strong').text(originalSubsPrice);
      } else {
        $('.frequency-bundle__one-time-heading .onetime_price').text(totalOneTimePrice);
        $(`.frequency-bundle .frequency-bundle__work-desc-price p.bundle_price s`).text(totalOneTimePrice);
        $('.frequency-bundle__work-desc-price .bundle_price strong').text(totalSubsciptionPrice);
      }

      //console.log('remainPrice subscription', remainPrice)
      if (remainPrice <= 0) {
        $('.progress-bundle-wrapper__heading .progress-bundle-wrapper__heading-left').html("Congrats! you've unlocked free shipping.");
        $('.progress-bundle-wrapper__heading-mob .progress-bundle-wrapper__heading-left').html("Congrats! you've unlocked free shipping.");
        
        $('.frequency-bundle__deliver .progress-bundle-wrapper__heading-right').removeClass('hide-msg');
        $('.progress-bundle-wrapper__heading-mob .progress-bundle-wrapper__heading-right').removeClass('hide-msg');
        $('.frequency-bundle__deliver .progress-bundle-wrapper__heading-right').html(`You’re saving <span>${savingInMoney}</span>`);
        $('.progress-bundle-wrapper__heading-mob .progress-bundle-wrapper__heading-right').html(`You’re saving <span>${savingInMoney}</span>`);
        
      } else {
        //$('.progress-bundle-wrapper__heading .progress-bundle-wrapper__heading-left span').text(remainPriceInMoney);
        $('.progress-bundle-wrapper__heading .progress-bundle-wrapper__heading-left').html(`You're <span>${remainPriceInMoney}</span> away from Free Shipping.`);
        $('.progress-bundle-wrapper__heading-mob .progress-bundle-wrapper__heading-left').html(`You're <span>${remainPriceInMoney}</span> away from Free Shipping.`);
        

        $('.frequency-bundle__deliver .progress-bundle-wrapper__heading-right').addClass('hide-msg');
        $('.progress-bundle-wrapper__heading-mob .progress-bundle-wrapper__heading-right').addClass('hide-msg');
        
      }

      if (total <= 0) {            
        $('.product-count button.add-btn1').attr('disabled', 'disabled');
        $('.product-count .sticky-button').attr('disabled', 'disabled');
      } else {
        $('.product-count button.add-btn1').removeAttr('disabled');
        $('.product-count .sticky-button').removeAttr('disabled');
      }

      let allTotal = (cartTotal + multiplyPrice) / 100;
      updateBundleProgressBar(allTotal);

      let subsciptionTotal = Shopify.formatMoney(multiplyPrice);
      $('p[title="order-total"] span').text(subsciptionTotal);

      });

    }

    function frequenceTotalCheck() {
      // change event for current one time and subscription

       // new code
       $('.frequency-bundle input:checked').each(function() {
        let freDataName = $(this).attr('data-name');

        if (freDataName === "one-time") {
            checkTotal();
        } else if (freDataName ===  "subscription") {
            subscriptionTotalCheck();
        }
       });

       $('.frequency-bundle input').on('change', function() {
        let frequencyName =  $(this).attr('data-name');
        if (frequencyName === 'one-time') {
            checkTotal();
        } else if (frequencyName == 'subscription') {
            subscriptionTotalCheck();
        }
       })
   }

   $('.frequency-bundle input').on('change', function() {    
    let frequencyName =  $(this).attr('data-name');
    if (frequencyName === 'one-time') {
        checkTotal();
    } else if (frequencyName == 'subscription') {
        subscriptionTotalCheck();
    }
   });


    // 24-02-2025
    $(".bundle-new-flavors__quantity").each(function () {
        let quantityContainer = $(this);
        let inputNumber = quantityContainer.find("input");
        let productHandle = inputNumber.attr("data-product-handle");
        let productID = Number(inputNumber.attr("data-product-id"));
        let productSellingID = Number(inputNumber.attr("data-selling-plan"));
        let minusBtn = quantityContainer.find(".icon-minus");
        let plusBtn = quantityContainer.find(".icon-plus");

      
        plusBtn.on("click", function () {
            let currentVal = parseInt(inputNumber.val(), 10) || 0;
            if (currentVal < 99) {
                let plusCounter = currentVal + 1;
                inputNumber.val(plusCounter);
                $(`.bundle-new-flavors__list input[value="${productHandle}"] + label`).click();

                frequenceTotalCheck();
            }
        });

        minusBtn.on("click", function () {
            let currentVal = parseInt(inputNumber.val(), 10) || 0;
            if (currentVal > 0) {
                let minusCounter = currentVal - 1;
                inputNumber.val(minusCounter);
                $(`.bundle-new-flavors__list input[value="${productHandle}"] + label`).click();

                frequenceTotalCheck();
            }
        });
    });
    // end 24-02-2025

    
    function checkAllData(type) {
      // last proper try array
      let newUpdatedData = {
        items: []
      };

      $('.bundle-new-flavors__quantity').each(function() {
        // Get the input element inside the current .bundle-new-flavors__quantity
        let $input = $(this).find('input');
        
        // Get the value of the input, data-product-id, and data-selling-plan
        let value = $input.val();
        let productId = $input.data('product-id');
        // let sellingPlan = $input.data('selling-plan');
        const selectFrequencyDeliver = document.querySelector('[name="frequency-deliver"]');
        const sellingPlan = selectFrequencyDeliver?.selectedOptions[0]?.getAttribute('data-selling-id');
        
        // Only process the item if the value is more than 0
        if (parseInt(value) > 0) {
          // Prepare the object to be pushed into items
          let item = {
            id: productId,
            quantity: parseInt(value) // Convert the value to a number
          };
    
          // If the type is not 'one-time', include selling_plan in the object
          if (type !== 'one-time') {
            item.selling_plan = sellingPlan;
          }
    
          // Push the object to newUpdatedData.items
          newUpdatedData.items.push(item);
        }
      });
      return newUpdatedData;
    }

    const modal = document.getElementById('subscription-upsell-modal');
    const closeBtn = document.querySelector('.subscription-modal__close');
    const declineBtn = document.querySelector('.subscription-modal__decline');
    const subscribeBtn = document.getElementById('upsell-subscribe-btn');

    function getCurrentVariantId() {
      const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return variantInput ? variantInput.value : null;
    }

    function openModal() {

      if(modal == null) {
        let newUpdatedData = checkAllData('one-time');
        addProducts(newUpdatedData);
        return;
      }

      const productTitle = document.querySelector('.product-banner__content-right > h1').innerText;
      const productHandle = document.querySelector('[name="flavor-radio"]:checked').getAttribute('data-product-handle')
      const image = document.querySelector('.bundle-product-media[data-product-name="' + productHandle + '"] .slide-for__img-box.slick-active img').src;

      // Get subscription price from page
      const priceCompElement = document.querySelector('.bundle_price s');
      const subscriptionCompPrice = priceCompElement
        ? priceCompElement.innerText.trim()
        : '';

      const priceElement = document.querySelector('.bundle_price strong');
      const subscriptionPrice = priceElement
        ? priceElement.innerText.trim()
        : '';

      // Get delivery dropdown
      // const deliverySelect = document.querySelector('select[name="frequency-deliver"]');

      // const plansContainer = document.getElementById('upsell-selling-plans');
      // plansContainer.innerHTML = '';

      // if (deliverySelect) {
      //   const clonedSelect = deliverySelect.cloneNode(true);
      //     plansContainer.appendChild(clonedSelect);

      // }

      const originalSelect = document.querySelector(
        '.frequency-bundle__deliver select[name="frequency-deliver"]'
      );

      const plansContainer = document.getElementById('upsell-selling-plans');
      if (plansContainer != null) {
        plansContainer.innerHTML = '';
      }

      if (originalSelect) {

        // Create new select for modal
        const newSelect = document.createElement('select');
        newSelect.name = 'frequency-deliver';
        newSelect.className = 'upsell-frequency-select';

        Array.from(originalSelect.options).forEach(option => {

          const newOption = document.createElement('option');

          // Keep value same
          newOption.value = option.value;
          newOption.textContent = option.value;

          // Preserve selected option
          if (option.selected) {
            newOption.selected = true;
          }

          newSelect.appendChild(newOption);

        });

        plansContainer.appendChild(newSelect);
      }

      document.getElementById('upsell-product-title').innerText = productTitle;
      document.getElementById('upsell-product-image').src = image;
      document.getElementById('upsell-compare-price').innerText = subscriptionCompPrice;
      document.getElementById('upsell-price').innerText = subscriptionPrice;

      modal.classList.remove('hidden');
      document.body.classList.add('overflow-hidden');
    }

    function closeModal() {
      modal.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');
    }

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (declineBtn) declineBtn.addEventListener('click', function () {
      let newUpdatedData = checkAllData('one-time');
      addProducts(newUpdatedData);
    });

    function syncSelect(sourceSelector, targetSelector) {
      document.addEventListener('change', function (e) {

        if (e.target.closest('#upsell-selling-plans')) {

          const selectedValue = e.target.value;

          const originalSelect = document.querySelector(
            '.frequency-bundle__deliver select[name="frequency-deliver"]'
          );

          if (!originalSelect) return;

          originalSelect.value = selectedValue;

          originalSelect.dispatchEvent(new Event('input', { bubbles: true }));
          originalSelect.dispatchEvent(new Event('change', { bubbles: true }));

        }

      });
    }

    syncSelect(
      '#upsell-selling-plans select[name="frequency-deliver"]',
      '.frequency-bundle__deliver select[name="frequency-deliver"]'
    );

    syncSelect(
      '.frequency-bundle__deliver select[name="frequency-deliver"]',
      '#upsell-selling-plans select[name="frequency-deliver"]'
    );

    const subscriptionPopupKey = "product_modal_last_shown";
    const sessionPopupKey = "product_modal_session_shown";
    const now = Date.now();
    const twentyFourHours = 24 * 60 * 60 * 1000;

    $(document).on('click', '.product-count button.add-btn1, .product-count .sticky-button', function (e) {

      let dataName = $('.frequency-bundle input:checked').attr('data-name');

      if (dataName == "one-time") {

        e.preventDefault();

        const variantId = getCurrentVariantId();

        fetch(`/variants/${variantId}.js`)
          .then(res => res.json())
          .then(variant => {

            fetch(`/products/${window.location.pathname.split('/products/')[1]}.js`)
              .then(res => res.json())
              .then(product => {
                const lastShown = localStorage.getItem(subscriptionPopupKey);
                const sessionShown = sessionStorage.getItem(sessionPopupKey);
                const shouldShowPopup =
                  !sessionShown &&
                  (!lastShown || (now - parseInt(lastShown, 10)) > twentyFourHours);

                console.log('shouldShowPopup =', shouldShowPopup);
                
                if (shouldShowPopup) {
                  openModal(product, variant);
                  localStorage.setItem(subscriptionPopupKey, now);
                  sessionStorage.setItem(sessionPopupKey, "true");
                } else {
                  var newUpdatedData = checkAllData('one-time');
                  addProducts(newUpdatedData);
                }

                subscribeBtn.onclick = function () {
                  document.querySelector('[data-name="subscription"]').click();
                  // document.querySelector('.add-btn1').click();
                  var newUpdatedData = checkAllData('subscription-type');
                  addProducts(newUpdatedData);
                };

              });

          });
      } else {
        // new code for subscription
        let newUpdatedData = checkAllData('subscription-type');
        //console.log('newUpdatedData',newUpdatedData);
        addProducts(newUpdatedData);
      }

    });

    // function for add.js
    function addProducts(itemsArray) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: itemsArray,
        dataType: "json",
        success: function (data) {
          addToCartAndOpenDrawer();
          if (modal) {
            setTimeout(() => {
              closeModal();
            }, 100);
          }

          let freeShippingPrice = Number($('.progress-bundle-wrapper__heading-left').attr('data-free-shipping'));
          let formatMoney = Shopify.formatMoney(freeShippingPrice);
          
          $('.bundle-new-flavors__quantity input').val(0);
          $('.frequency-bundle__work-desc-price .label-bag span').html('X')

          let originalOnetimePrice = $('.bundle-new-flavors__list input[name="flavor-radio"]:checked').attr('data-product-onetime-price');
          let originalSubsPrice = $('.bundle-new-flavors__list input[name="flavor-radio"]:checked').attr('data-product-sub-price');

          $('.frequency-bundle__one-time-heading .onetime_price').text(originalOnetimePrice);
          $(`.frequency-bundle .frequency-bundle__work-desc-price p.bundle_price s`).text(originalOnetimePrice);
          $(`.frequency-bundle .frequency-bundle__work-desc-price p.bundle_price strong`).text(originalSubsPrice);

          //$('.progress-bundle-wrapper__heading .progress-bundle-wrapper__heading-left').html(`You're <span>${formatMoney}</span> away from Free Shipping.`);
          //updateBundleProgressBar(0);
          $('.product-count button.add-btn1').attr('disabled', 'disabled');
          $('.product-count .sticky-button').attr('disabled', 'disabled');
          
        },
        error: function (error) {
          console.log("Error", error);
        },
      });
    }

  // validate qauntity selector and place 1 on unwanted input(26-04)
  function isSetValue(ele){
    let max = ele.getAttribute('max');
    if(ele.value == "" || ele.value == " " || ele.value == "0" ){
      ele.value = 1;
    }

    if(ele.value > max){
      ele.value = max;
    }
  }

  function checkInputOfBundle() {

    // new code
    $(document).on("change", ".frequency-bundle input", function () {
        let frequencyName = $(this).attr("data-name");

        if (frequencyName === "one-time") {
            checkTotal();
        } else if (frequencyName === "subscription") {
            subscriptionTotalCheck();
        }
    });

  }

  checkInputOfBundle();

  $(document).on('change', '.bundle-new-flavors__main .bundle-new-flavors__list input[name="flavor-radio"]', function() {
  let product_handle = $(this).attr('value');
  let productTitle = $(this).attr('data-product-title');
  $('.product-banner__content-right h1').text(productTitle);
  checkInputOfBundle();

    // new code
    $(`.frequency-bundle input:checked`).each(function() {
        let frequencyName =  $(this).attr('data-name');
        if (frequencyName === 'one-time') {
            checkTotal();
        } else if (frequencyName == 'subscription') {
            subscriptionTotalCheck();
            //console.log('subscription')
        }
    })

  
  $('.bundle-product-media').each(function() {
    let bundleMediaName = $(this).attr('data-product-name');
    if (product_handle === bundleMediaName) {
      $('.bundle-product-media').hide();

      // destroy slick slider
      $('.js-slide-for-img').slick('unslick');
      $('.js-slide-now-img').slick('unslick');

      // reinitialize
      bannerSlider();
      $(`.bundle-product-media[data-product-name="${product_handle}"]`).show();
    }
  });


  // tab
  $('.tab-detail').each(function() {
    let tabProductName = $(this).attr('data-product-name');
    if (product_handle === tabProductName) {
      $('.tab-detail').hide();
      tabbing();
      $(`.tab-detail[data-product-name="${product_handle}"]`).show();
    }
  });

  // ingredients section
  $('.ingredient-desc').each(function() {
    let secProductName = $(this).attr('data-product-handle');
    if (product_handle === secProductName) {
      $('.ingredient-desc').hide();

      $(`.ingredient-desc[data-product-handle="${product_handle}"]`).show();
    }
  });


  // product type info
  
  $('.product-banner__content-right .sub-heading').each(function() {
    let typeProductHandle = $(this).attr('data-product-handle');
    if (product_handle === typeProductHandle) {
      $('.product-banner__content-right .sub-heading').hide();
      $(`.product-banner__content-right .sub-heading[data-product-handle="${product_handle}"]`).css('display', 'flex');
    }
  });

  // ingredient tab section
  if ($('.tab-content.tab_work').length > 0) {
    $('.tab-content.tab_work').each(function() {
      let tabProductHandle = $(this).attr('data-product-handle');
      if (product_handle === tabProductHandle) {
        $('.tab-content.tab_work').hide();
        $(`.tab-content.tab_work[data-product-handle="${product_handle}"]`).show();
      }
    });
  }

  // super ingredients section
  if ($('.bundle-img-content').length > 0) {
    $('.bundle-img-content').each(function() {
      let superProductHandle = $(this).attr('data-product-handle');
      if (product_handle === superProductHandle) {
        $('.bundle-img-content').hide();
        $(`.bundle-img-content[data-product-handle="${product_handle}"]`).css('display', 'flex');
      }
    });
  }


  // icon text section
  if ($('.icon-text-section').length > 0) {
    $('.icon-text-section').each(function() {
      let iconProductHandle = $(this).attr('data-product-name');
      if (product_handle === iconProductHandle) {
        $('.icon-text-section').hide();
        $(`.icon-text-section[data-product-name="${product_handle}"]`).css('display', 'flex');
      }
    })
  }

  

});
});
